import { render, staticRenderFns } from "./PrestationsMaquillage.vue?vue&type=template&id=34fd5440&"
import script from "./PrestationsMaquillage.vue?vue&type=script&lang=js&"
export * from "./PrestationsMaquillage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports